import React, { useState, useEffect } from 'react';
import firebase from "firebase";
const database = firebase.firestore();
function Portfolio() {
    const [projects, setProjects] = useState([])

    useEffect(()=>{

        database.collection("portfolio").get().then(querySnapshot => {
            setProjects(querySnapshot.docs.map(doc => doc.data()));
        })

    },[])

    const portfolios = () =>{
        return projects.map(function(projects){
            var projectImage = projects.img;
            return <div key={projects.title} className="columns portfolio-item">
                <div className="item-wrap" style={{height:"300px", width:"300px"}}>
                    <a href={projectImage} title={projects.title}>
                        <img alt={projects.title} src={projectImage} />
                        <div className="overlay">
                            <div className="portfolio-item-meta">
                                <h5>{projects.title}</h5>
                                <p>{projects.description}</p>
                            </div>
                        </div>
                        <div className="link-icon"><i className="fa fa-link"></i></div>
                    </a>
                </div>
            </div>
        })
    }


    return (
      <section id="portfolio">

      <div className="row">

         <div className="twelve columns collapsed">

            <h1>Check Out Some of My Works.</h1>

            <div id="portfolio-wrapper" className="bgrid-quarters s-bgrid-thirds cf">
                {portfolios()}
            </div>
          </div>
      </div>
   </section>
    );

}

export default Portfolio;



// WEBPACK FOOTER //
// ./src/Components/Portfolio.js